import styled from 'styled-components'
import { Link } from 'react-router-dom'
import { PrimaryButton } from './button'

export const FollowerBarContainer = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  z-index: 1000;
  background-color: ${({ theme }) => theme.secondary};
  color: ${({ theme }) => theme.primaryContrast};
  padding: 12px 20px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.15);
  display: flex;
  justify-content: space-between;
  align-items: center;
  flex-wrap: wrap;
  gap: 10px;

  @media (max-width: 768px) {
    padding: 10px 15px;
    font-size: 0.9rem;
    flex-direction: column;
    align-items: stretch;
  }
`

export const StatusSection = styled.div`
  display: flex;
  flex-direction: column;
  gap: 4px;

  @media (max-width: 768px) {
    align-items: center;
    text-align: center;
  }
`

export const StatusLabel = styled.div`
  font-weight: bold;
  font-size: 0.95rem;

  @media (max-width: 768px) {
    font-size: 0.9rem;
  }
`

export const StatusInfo = styled.div`
  font-size: 0.85rem;
  opacity: 0.9;

  @media (max-width: 768px) {
    font-size: 0.8rem;
  }
`

export const LeaveButton = styled(PrimaryButton)`
  background-color: ${({ theme }) => theme.tertiary};
  border-color: ${({ theme }) => theme.tertiary};
  font-weight: bold;
  white-space: nowrap;

  &:hover:not(:disabled) {
    opacity: 0.9;
  }

  @media (max-width: 768px) {
    width: 100%;
  }
`

export const EndedBarContainer = styled(FollowerBarContainer)`
  background-color: #f39c12;
  color: white;
`

export const ActionSection = styled.div`
  display: flex;
  gap: 10px;
  align-items: center;
  flex-wrap: wrap;

  @media (max-width: 768px) {
    width: 100%;
    justify-content: center;
  }
`

export const HomeLink = styled(Link)`
  color: white;
  text-decoration: none;
  padding: 8px 16px;
  background-color: rgba(255, 255, 255, 0.2);
  border-radius: 4px;
  font-weight: bold;
  white-space: nowrap;
  transition: background-color 0.2s ease;

  &:hover {
    background-color: rgba(255, 255, 255, 0.3);
    color: white;
    text-decoration: none;
  }

  @media (max-width: 768px) {
    flex: 1;
    text-align: center;
  }
`
